"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultTransitionTime = void 0;
const DefaultTransitionTime = 300;
exports.DefaultTransitionTime = DefaultTransitionTime;
//# sourceMappingURL=Constants.js.map